export default {
  dontShowAgain: false,
  viewCount: 0,
};
